import { render } from "./App.vue?vue&type=template&id=b155b550"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b155b550&lang=scss"
script.render = render

export default script